import type { loginResponse } from '~/models'
import { $apiPost } from '~/utils/request'

// 記得將 export 加入到 ./index.ts

export const Post = body => $apiPost<loginResponse>(`/v1/login`, body)

export const LoginFromRootLawWeb = body => $apiPost<loginResponse>(`/v1/login/fromRootLawWeb`, body)
